import { render, staticRenderFns } from "./DriverGroup.vue?vue&type=template&id=3bf88007&"
import script from "./DriverGroup.vue?vue&type=script&lang=js&"
export * from "./DriverGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports